export enum AICampaign {
	AI = 'AI',
	INTUITION = 'Intuition',
	SKIP = 'Skip',
}

export type AICampaignOption = AICampaign.AI | AICampaign.INTUITION | AICampaign.SKIP;
export type AICampaignSelectedOption = AICampaign.AI | AICampaign.INTUITION;

export type AICampaignSelection = { selectedOption: AICampaignSelectedOption; selectionDate: number };
